import React from 'react';
import { AppProvider } from './providers/AppProvider';

function App() {
  return <AppProvider />;
}

export default App;
